// Accordion functionality
  document.querySelectorAll(".category_item").forEach((category) => {
    const faqItems = category.querySelectorAll(".faq_item");
  
    faqItems.forEach((faq, index) => {
      const answer = faq.querySelector(".faq_ans");
  
      // Ensure answers start hidden (CSS already does this)
      // answer.style.overflow = "hidden";
      // answer.style.transition = "max-height 0.3s ease-out";
      
      // Open the first item in each category
      if (index === 0) {
        faq.classList.add("open");
        answer.style.maxHeight = answer.scrollHeight + "px"; // Expand first answer
      }
    });
  
    faqItems.forEach((faqItem) => {
      const qus = faqItem.querySelector(".faq_qus");
      const ans = faqItem.querySelector(".faq_ans");
  
      qus.addEventListener("click", () => {
        // If already open, close it
        if (faqItem.classList.contains("open")) {
          faqItem.classList.remove("open");
          ans.style.maxHeight = "0px";
          return;
        }
  
        // Close all other answers in the same category
        faqItems.forEach((item) => {
          const itemAns = item.querySelector(".faq_ans");
          item.classList.remove("open");
          itemAns.style.maxHeight = "0px"; // Collapse answer
        });
  
        // Open the clicked FAQ
        faqItem.classList.add("open");
        ans.style.maxHeight = ans.scrollHeight + "px"; // Expand answer smoothly
      });
    });
  });

// Accordion functionality



    
// FAQ page Search Bar custom functionality
if (window.location.href.includes("/pages/faqs")) {
  var i, input, ul, li, searchValue, itemValue, cancelBtn;
  input = document.getElementById('srchInpt');
  li = document.querySelectorAll('#serchItems .accBox'); 
  ul = document.querySelector('#serchItems');
  // cancelBtn = document.querySelector(".faq_canCel"); 
  // var srchBtn = document.querySelector('#srchInpt_btn');
  
  input.addEventListener('keyup',function(){
    searchValue = input.value.trim().replace(/\s+/g, ' ').toUpperCase();
    for(i = 0; i < li.length; i++){
      itemValue = li[i].querySelector(".faq_qus").textContent;
      itemValue = itemValue.toUpperCase();
      
      if(itemValue.indexOf(searchValue) > -1){
        li[i].style.display = '';
        li[i].setAttribute("data-number", 1);
        li[i].closest(".accBox_wrap").style.paddingTop = '0px';
        li[i].closest(".accBox_wrap").querySelector(".category_heading").style.display = 'none';
        li[i].closest(".faqMain").querySelector(".category_nameBtn").style.display = 'none';
      } else {
        li[i].style.display = 'none';
        li[i].setAttribute("data-number", 0);
        li[i].closest(".accBox_wrap").style.paddingTop = '0px';
        li[i].closest(".accBox_wrap").querySelector(".category_heading").style.display = 'none';
        li[i].closest(".faqMain").querySelector(".category_nameBtn").style.display = 'none';
      }

      if(searchValue == '' || searchValue == ' '){
        li[i].closest(".accBox_wrap").style.paddingTop = '72px';
        li[i].closest(".accBox_wrap").querySelector(".category_heading").style.display = 'block';
        li[i].closest(".faqMain").querySelector(".category_nameBtn").style.display = 'flex';
      }

      // if (searchValue == 0) {
      //   cancelBtn.style.display = "none";
      // } else {
      //   cancelBtn.style.display = "block";
      // }    
    }
    setTimeout(function () {
      let counterr = 0;
      document.querySelectorAll("[data-number='1']").forEach(function (lis) {
        counterr++;
      });
      if (counterr == 0) {
        console.log("Not found!");
      }
    }, 1000);

    // Get all div elements
    const divs = document.querySelectorAll('.faq_item');
    let allHidden = true;
    // Iterate through each div and check if display is none
    divs.forEach(div => {
      const computedStyle = window.getComputedStyle(div);
      if (computedStyle.getPropertyValue('display') !== 'none') {
        allHidden = false;
        // If any div is not hidden, you can exit the loop early
        return;
      }
    });
    
    // If all divs are hidden, execute the if block, otherwise execute the else block
    var blgCrd = document.querySelector('.noResult_type');
    if (allHidden) {
      console.log("All divs have display: none.");
      blgCrd.classList.add("show_text");
    } else {
      blgCrd.classList.remove("show_text");
    }
  });

  // cancelBtn.addEventListener("click",() => {
  //   cancelBtn.style.display = 'none';
  // });
}
// FAQ page Search Bar custom functionality


// Scroll to that category
  const trigrBtns = document.querySelectorAll(".category_nameBtn .categoryBtn");

  trigrBtns.forEach((btn) => {
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      // trigrBtns.forEach((b) => b.classList.remove("active"));
      document.querySelector(".categoryBtn.active")?.classList.remove("active");
      this.classList.add("active");
      
      const targetId = this.getAttribute("href").substring(1); // Remove the "#"
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
// Scroll to that category


